@if (survey && radioForm) {
  @for (questions of survey; track $index) {
    <div class="one-radio-info-container">
      <app-info-box title="{{ questions.category }}" description="{{ 'steps.oneRadioInfo.subtitle' | translate }}"></app-info-box>
      <div class="radio-container">
        <form [formGroup]="radioForm">
          <nz-radio-group [formControlName]="$index">
            @for (radioButton of questions.items; track radioButton) {
              <label nz-radio [nzValue]="radioButton.surveyValueAnswer" [ngClass]="'uppertext'">
                {{ radioButton.surveyValueAnswer }}
              </label>
            }
          </nz-radio-group>
        </form>
      </div>
    </div>
  }
}
@if (uploadForm) {
  <div class="load-docs-container">
    <h2>Carica referto</h2>
    <span>Potrai inserire tutto ciò che riguarda la tua storia clinica.</span>
    <form [formGroup]="uploadForm" nz-form nzLayout="vertical" class="upload-layout">
      @if (!document && !documentIsUploading) {
        <nz-upload [nzBeforeUpload]="beforeUpload" nzListType="text" [nzMultiple]="false" [nzShowUploadList]="false" nzType="drag">
          <div class="upload-area">
            <span nz-icon nzType="inbox" nzTheme="outline"></span>
            <p class="upload-message">
              <span class="upload-link">Fai click qui</span> o sposta il file all’interno dell’area tratteggiata per caricare il file (in formato pdf, jpeg, png)
            </p>
          </div>
        </nz-upload>
      }

      @if (!document && documentIsUploading) {
        <nz-progress [nzPercent]="progressPercentage"></nz-progress>
      }

      @if (document && !documentIsUploading) {
        <div class="document-container">
          <span>Documento caricato</span>
          <span class="document">{{ document.name }}</span>
          <span class="delete-doc" (click)="deleteDoc()">
            <span nz-icon nzType="rest" nzTheme="outline"></span>
            {{ 'loadDocumentModal.delete' | translate }}
          </span>
        </div>
      }
      <nz-form-item class="service-container">
        <nz-form-label [nzFor]="'documentType'">{{ 'loadDocumentModal.service_type' | translate }}</nz-form-label>
        <nz-radio-group class="service-container" formControlName="documentType">
          <label nz-radio nzValue="Referto visita">{{ 'loadDocumentModal.visit_report' | translate }}</label>
          <label nz-radio nzValue="Referto esame diagnostico">{{ 'loadDocumentModal.diagnostic_report' | translate }}</label>
          <label nz-radio nzValue="Referto analisi del sangue">{{ 'loadDocumentModal.blood_report' | translate }}</label>
        </nz-radio-group>
      </nz-form-item>
    </form>
  </div>
}
